class SlideshowRenderer extends HTMLElement {
  connectedCallback() {
    let items = [];
    const raw = this.getAttribute('data-json');
    if (raw) {
      try {
        items = JSON.parse(raw);
        this.removeAttribute('data-json');
      } catch (e) {
        console.warn('[SlideshowRenderer] invalid JSON:', e);
      }
    }

    this.innerHTML = `
        <div class="resource-list__carousel">
          <slideshow-component auto-hide-controls>
            <slideshow-container ref="slideshowContainer">
              <slideshow-slides tabindex="-1" ref="scroller" role="list" gutters="start end">
                ${
                  Array.isArray(items)
                    ? items
                        .map(
                          (item, idx) => `
                      <slideshow-slide
                        ref="slides[]"
                        class="custom-slide product-tile"
                        aria-hidden="false"
                        role="listitem"
                        aria-setsize="${items.length}"
                        aria-posinset="${idx + 1}"
                        style="view-timeline-name: --slide-; --product-media-fit: cover;">
                        <div class="container-entry">
                          <product-card-custom
                            class="product-card-custom product-card-custom--info-padding"
                            data-json='${JSON.stringify(item).replace(
                              /'/g,
                              '&apos;'
                            )}'>
                          </product-card-custom>
                        </div>
                      </slideshow-slide>
                    `
                        )
                        .join('')
                    : ''
                }
              </slideshow-slides>
              <slideshow-arrows ref="arrows" position="center" shape="circle">
                <button
                  class="slideshow-control slideshow-control--previous slideshow-control--shape-circle slideshow-control--style-custom-arrow button flip-x"
                  aria-label="Previous slide"
                  on:click="/previous"
                  ref="previous">
                  <span class="svg-wrapper icon-custom-arrow">
                    <svg class="icon icon-arrow-right" width="10" height="22" viewBox="0 0 10 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.80908 19.1914L0.92529 18.3076L8.23242 11L0.92529 3.69238L1.80908 2.80859L10 11L1.80908 19.1914Z" fill="black"></path>
                    </svg>
                  </span>
                </button>
                <button
                  class="slideshow-control slideshow-control--next slideshow-control--shape-circle slideshow-control--style-custom-arrow button"
                  aria-label="Next slide"
                  on:click="/next"
                  ref="next">
                  <span class="svg-wrapper icon-custom-arrow">
                    <svg class="icon icon-arrow-right" width="10" height="22" viewBox="0 0 10 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.80908 19.1914L0.92529 18.3076L8.23242 11L0.92529 3.69238L1.80908 2.80859L10 11L1.80908 19.1914Z" fill="black"></path>
                    </svg>
                  </span>
                </button>
              </slideshow-arrows>
            </slideshow-container>

            <div class="slideshow-controls-wrapper">
              <div class="slideshow-scrubber" ref="scrubber" aria-hidden="true">
                <div class="slideshow-scrubber__track" ref="scrubberTrack">
                  <button
                    class="slideshow-scrubber__thumb"
                    ref="scrubberThumb"
                    type="button"
                    role="slider"
                    aria-label="Scrub slides"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-valuenow="0">
                  </button>
                </div>
              </div>
            </div>
          </slideshow-component>
        </div>
      `;
  }
}

customElements.define('slideshow-renderer', SlideshowRenderer);
